import * as Dialog from "@radix-ui/react-dialog";
import type { ReactNode } from "react";

interface DrawerItem {
  id: string;
  label: string;
  icon: ReactNode;
  onSelect: () => void;
}

interface FormatDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  items: DrawerItem[];
}

/**
 * Bottom-sheet drawer for the secondary formatting actions.
 * Uses Radix Dialog under the hood for focus / keyboard handling.
 */
export function FormatDrawer({
  open,
  onOpenChange,
  items,
}: FormatDrawerProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/40 data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <Dialog.Content
          aria-describedby={undefined}
          className="fixed inset-x-0 bottom-0 z-50 rounded-t-2xl bg-[var(--tg-bg)] p-3 shadow-2xl focus:outline-none"
          style={{
            paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))",
          }}
        >
          <Dialog.Title className="px-2 pb-2 text-sm font-medium text-[var(--tg-hint)]">
            Formatting
          </Dialog.Title>
          <ul className="grid grid-cols-2 gap-2">
            {items.map((it) => (
              <li key={it.id}>
                <button
                  type="button"
                  onClick={() => {
                    it.onSelect();
                    onOpenChange(false);
                  }}
                  className="flex w-full items-center gap-3 rounded-lg bg-[var(--tg-secondary-bg)] px-3 py-3 text-left text-[var(--tg-text)] active:opacity-80"
                >
                  <span className="text-[var(--tg-hint)]">{it.icon}</span>
                  <span>{it.label}</span>
                </button>
              </li>
            ))}
          </ul>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
